import { ApolloLink } from 'apollo-link';
import { getMainDefinition, hasDirectives, removeDirectivesFromDocument } from 'apollo-utilities';
import { DocumentNode } from 'graphql';

const GATEWAY_DIRECTIVE = 'gateway';

export const stripGatewayDirective = new ApolloLink((operation, forward) => {
  if (!hasDirectives([GATEWAY_DIRECTIVE], operation.query)) {
    return forward(operation);
  }
  const strippedQuery = removeDirectivesFromDocument(
    [{ name: GATEWAY_DIRECTIVE }],
    operation.query
  );
  if (strippedQuery) {
    operation.query = strippedQuery;
  }
  return forward(operation);
});

export const isGatewayRequest = (query: DocumentNode) => {
  const definition = getMainDefinition(query);
  const foundDirective = definition.directives?.find(
    directive => directive.name.value === GATEWAY_DIRECTIVE
  );
  return !!foundDirective;
};
